import { useDispatch } from 'react-redux';
import styles from './PatientDetailsMenu.module.scss';
import cx from 'classnames';
import { Menu, Text } from 'components';
import { useDevice } from 'hooks';
import { appActions } from 'store/app/slice';
import { selectCurrentUser } from 'store/auth/selectors';
import { selectCurrentPatientCase } from 'store/patients/selectors';
import { useSelector } from 'store/utils';
import { TreatmentPlanTask, UserRole } from 'types';

export const PatientDetailsMenu = () => {
  const dispatch = useDispatch();

  const { isTablet } = useDevice();

  const currentUser = useSelector(selectCurrentUser);
  const currentPatientCase = useSelector(selectCurrentPatientCase);

  const onHandleEditClick = () => {
    dispatch(appActions.setIsModalOpened({ name: 'editPatientInfo', isOpened: true }));
  };

  const onOpenArchiveModal = () => {
    dispatch(appActions.setIsModalOpened({ name: 'archivePatient', isOpened: true }));
  };

  const onOpenTreatmentToggleModal = () => {
    dispatch(appActions.setIsModalOpened({ name: 'treatmentModal', isOpened: true }));
  };

  const onHandleDeleteClick = () => {
    dispatch(appActions.setIsModalOpened({ name: 'deletePatient', isOpened: true }));
  };

  const contents = {
    [UserRole.CLINIC]: [
      {
        handler: onHandleEditClick,
        text: 'Edit patient info',
      },
      {
        handler: onOpenTreatmentToggleModal,
        text: currentPatientCase?.isTaskBlocked ? 'Return from out of treatment' : 'Out of treatment',
      },
    ],
    [UserRole.ADMIN]: [
      {
        handler: onOpenArchiveModal,
        text: currentPatientCase?.isArchived ? 'Restore from archive' : 'Add to archive',
      },
      {
        handler: onHandleEditClick,
        text: 'Edit patient info',
      },
      {
        handler: onHandleDeleteClick,
        text: 'Delete patient',
      },
    ],
    [UserRole.DOCTOR]: [],
    [UserRole.READ_ONLY]: [],
  };

  if (
    currentPatientCase &&
    (currentPatientCase.isArchived || currentPatientCase.task !== TreatmentPlanTask.TO_SUBMIT)
  ) {
    contents[UserRole.CLINIC] = contents[UserRole.CLINIC].slice(1);
  }
  if (currentPatientCase && !currentPatientCase.isArchived) {
    contents[UserRole.ADMIN] = contents[UserRole.ADMIN].slice(0, 2);
  }

  if (currentPatientCase && currentPatientCase.isArchived && currentPatientCase.task === TreatmentPlanTask.TO_SUBMIT) {
    contents[UserRole.ADMIN].splice(1, 1);
  }

  return (
    currentUser && (
      <Menu>
        <ul className={cx(styles.list, { [styles.isTouchScreen]: isTablet })}>
          {contents[currentUser.role].map((listItem) => (
            <li className={styles.listItem} key={listItem.text} onClick={listItem.handler}>
              <Text type={isTablet ? 'subtitle2' : 'body2'}>{listItem.text}</Text>
            </li>
          ))}
        </ul>
      </Menu>
    )
  );
};
